import * as JobTypes from "../types/jobData";

export class JobFinder {
  constructor() {}

  /**
   *
   * @param jobIDs  - Array of job IDs
   * @param allJobs - Array of all jobs (UNFILTERED from filters (eg. search & filter))
   * @returns
   */
  static findJobsByID(jobIDs: number[], allJobs: JobTypes.jobData[]): JobTypes.jobData[] {
    const foundJobs = allJobs.filter((job) => {
      return jobIDs.includes(job.id);
    });

    return foundJobs;
  }
}
